import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var initializeBackgrounds = createAction(actionKey + ".INIT", function () { return ({}); });
export var saveBackground = createAction(actionKey + ".SAVE_BACKGROUND", function (deviation, backgroundId) { return ({
    deviation: deviation,
    backgroundId: backgroundId,
}); });
export var saveBackgroundSuccess = createAction(actionKey + ".SAVE_BACKGROUND.SUCCESS", function (deviationId, backgroundId) { return ({
    deviationId: deviationId,
    backgroundId: backgroundId,
}); });
export var saveBackgroundFail = createAction(actionKey + ".SAVE_BACKGROUND.FAIL", function (deviationId, backgroundId) { return ({
    deviationId: deviationId,
    backgroundId: backgroundId,
}); });
export var setBackground = createAction(actionKey + ".SET_BACKGROUND", function (deviationId, backgroundId) { return ({
    deviationId: deviationId,
    backgroundId: backgroundId,
}); });
export var showBackgroundPicker = createAction(actionKey + ".SHOW_BG_PICKER", function (deviation) { return ({ deviation: deviation }); });
export var fetchBackgrounds = createAction(actionKey + ".FETCH_BACKGROUNDS", function () { return ({}); });
export var previewBackground = createAction(actionKey + ".PREVIEW_BACKGROUND", function (backgroundId) { return ({
    backgroundId: backgroundId,
}); });
//# sourceMappingURL=actions.js.map